
import { ADDDEDUCTIONCOMONEN, ADDOTHERALLOWANCE, ADDSALARYCOMPONENT, ADDSALARYINCENTIVE, GETACTIVEEMPLOYEELIST, GETALLADVANCEFOR, GETALLCUSTOMERADVACE, GETALLDEDUCTIONCOMPONEN, GETALLOTHERALLOWANCE, GETALLSALARYCOMPONENT, GETALLSALARYINCENTIVE, GETCOUNTERSALESCUSTOMERS, UPDATEOTHERALLOWANCE, UPDATESALARYCOMPONENT, UPDATESALARYINCENTIVE,UPDATEDEDUCTIONCOMPONENT } from "../../utils/api"
import axios from "../../utils/axios"

export const getA=async(payload,callback)=>{
    await axios.post(GETALLCUSTOMERADVACE,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}


export const getAllIncentive=async(callback)=>{
    await axios.get(GETACTIVEEMPLOYEELIST).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}






export const getData=async(callback)=>{
    await axios.get(GETALLSALARYINCENTIVE).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}


export const getAllSalaryComponent=async(callback)=>{
    await axios.get(GETALLSALARYCOMPONENT).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}
export const getAllDeduction=async(callback)=>{
    await axios.get(GETALLDEDUCTIONCOMPONEN).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
} 



export const getAllaallownce=async(callback)=>{
    await axios.get(GETALLOTHERALLOWANCE).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
} 
export const addSalaryIncentive=async(payload,callback)=>{
    await axios.post(ADDSALARYINCENTIVE,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}
export const addAllowance=async(payload,callback)=>{
    await axios.post(
        ADDOTHERALLOWANCE,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}
export const addSalaryDeduction=async(payload,callback)=>{
    await axios.post(ADDDEDUCTIONCOMONEN,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}

export const updateSalaryIncentive=async(payload,callback)=>{
    await axios.post(UPDATESALARYINCENTIVE,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}

export const updateAllowance=async(payload,callback)=>{
    await axios.post(UPDATEOTHERALLOWANCE,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}




export const updateSalaryDeduction=async(payload,callback)=>{
    await axios.post(UPDATEDEDUCTIONCOMPONENT,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}





export const addSalaryComponent=async(payload,callback)=>{
    await axios.post(ADDSALARYCOMPONENT,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}


export const updateSalaryComponent=async(payload,callback)=>{
    await axios.post(UPDATESALARYCOMPONENT,payload).then((res)=>{
        callback(res)
    }).catch((err)=>{
        console.log(err)
    })
}
